enum WorkspaceProjectAiChatFileStatus {
  active = 'active',
  pending = 'pending',
  processing = 'processing',
  failed = 'failed',
  deleted = 'deleted',
}

export default WorkspaceProjectAiChatFileStatus
